import { deliveryMappingKeys } from './mappings';

export default rawData =>
    Object.fromEntries(
        Object.keys(deliveryMappingKeys).map(key => [[deliveryMappingKeys[key]], rawData[key]])
    );
